import { useState } from 'react';

import { ButtonGroupSection } from './ButtonGroupSection';
import { ButtonSection } from './ButtonSection';
import { ChipSection } from './ChipSection';
import { IconsSection } from './IconsSection';
import { SelectSection } from './SelectSection';
import styles from './EditComponents.module.css';

export const EditComponents = () => {
  const [sections, setSections] = useState<string[]>([]);

  const isSectionVisible = (section: string) => sections.includes(section);
  const toggleSection = (section: string) => () => {
    const index = sections.indexOf(section);
    if (index === -1) {
      setSections([...sections, section]);
    } else {
      setSections([...sections.slice(0, index), ...sections.slice(index + 1)]);
    }
  };

  return (
    <div className="c-app__page u-margin-top-lg o-container">
      <div className="u-padding-horizontal-xxl">
        <div className="c-view__header u-margin-bottom-md">
          <div className="o-grid o-grid--unpad o-grid--bottom">
            <div className="o-grid__cell o-grid__cell--width-10">
              <h2>Edit components</h2>
              <p>This is a test page for components used in edit mode.</p>
            </div>
            <div className="o-grid__cell o-grid__cell--width-10">
              <p>Select components:</p>
              <ul>
                <li>
                  <input
                    type="checkbox"
                    id="showSectionIcons"
                    checked={isSectionVisible('Icons')}
                    onChange={toggleSection('Icons')}
                  />
                  <label htmlFor="showSectionIcons">Icons</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    id="showSectionButton"
                    checked={isSectionVisible('Button')}
                    onChange={toggleSection('Button')}
                  />
                  <label htmlFor="showSectionButton">Button</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    id="showSectionButtonGroup"
                    checked={isSectionVisible('ButtonGroup')}
                    onChange={toggleSection('ButtonGroup')}
                  />
                  <label htmlFor="showSectionButtonGroup">ButtonGroup</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    id="showSectionSelect"
                    checked={isSectionVisible('Select')}
                    onChange={toggleSection('Select')}
                  />
                  <label htmlFor="showSectionSelect">Select</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    id="showSectionChip"
                    checked={isSectionVisible('Chip')}
                    onChange={toggleSection('Chip')}
                  />
                  <label htmlFor="showSectionChip">Chip</label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="c-view__content">
          <div className={styles.container}>
            {isSectionVisible('Icons') && <IconsSection />}
            {isSectionVisible('Button') && <ButtonSection />}
            {isSectionVisible('ButtonGroup') && <ButtonGroupSection />}
            {isSectionVisible('Select') && <SelectSection />}
            {isSectionVisible('Chip') && <ChipSection />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditComponents;
